import { createContext, useState, useContext, PropsWithChildren } from 'react'
import { Oval } from 'react-loader-spinner';

interface FullScreenLoaderInterface {
  showLoader?: Function;
  hideLoader?: Function;
}

const FullScreenLoaderContext = createContext<FullScreenLoaderInterface>({});

export const FullScreenLoaderProvider = ({ children }: PropsWithChildren) => {
  const [loading, setLoading] = useState<boolean>(false);

  const showLoader = () => {
    setLoading(true);
  }
  const hideLoader = () => {
    setLoading(false);
  }

  return (
    <FullScreenLoaderContext.Provider value={{ showLoader, hideLoader }}>
      {children}

      {loading && (
        <div className="full-screen-loader">
          <Oval
            height="100"
            width="100"
            color='white'
            ariaLabel='loading'
          />
        </div>
      )}
    </FullScreenLoaderContext.Provider>
  )
}

export const useFullScreenLoader = () => useContext(FullScreenLoaderContext);